import React, { useState } from "react";
import { Collapse } from "components";
import { SwapIcon1, SwapIcon2, SwapIcon3, SwapIcon4, SwapIcon5 } from "./config";
import useMobile from "../../../../../../../hooks/useMobile";
import { CollapseArrow } from "../config";

import "./index.scss";



const HowTo = () => {

	const [isHelpOpen, setHelp] = useState(false);
	const isMobile = useMobile();

	return <>

		<div className="settings-content mb-4">
			<div className="settings-content-title how" onClick={() => isMobile ? setHelp(!isHelpOpen) : null}>
				Getting started
				{isMobile ? <div style={isHelpOpen ? { transform: "rotate(180deg)" } : {}}><CollapseArrow /></div> : null}
			</div>

			<Collapse isOpen={isMobile ? isHelpOpen : true}>
				<div className="settings-how">
					<div>
						<div>
							<SwapIcon1 />
						</div>
						Payout from the original crypto (e.g. BTC) is sent
					</div>
					<div>
						<div>
							<SwapIcon2 />
						</div>
						Merchant receives email, with a note about the swap
					</div>
					<div>
						<div>
							<SwapIcon3 />
						</div>
						Swap is initiated
					</div>
					<div>
						<div>
							<SwapIcon4 />
						</div>
						Swap is completed
					</div>
					<div>
						<div>
							<SwapIcon5 />
						</div>
						Merchant receives the swapped Crypto + an email
					</div>
				</div>
			</Collapse>
		</div>

	</>
}

export default HowTo;
